import { render, staticRenderFns } from "./AstraTopElementStrategyTargetTableColumn.vue?vue&type=template&id=11861e5e&scoped=true"
import script from "./AstraTopElementStrategyTargetTableColumn.vue?vue&type=script&lang=js"
export * from "./AstraTopElementStrategyTargetTableColumn.vue?vue&type=script&lang=js"
import style0 from "./AstraTopElementStrategyTargetTableColumn.vue?vue&type=style&index=0&id=11861e5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11861e5e",
  null
  
)

export default component.exports